import styled from '@emotion/styled'

// In-flow (not fixed/sticky) footer. `margin-top: auto` inside a flex-column
// parent pushes it to the bottom when the page content is shorter than the
// viewport; on taller pages it simply follows the content and scrolls with it.
export const AppFooterContainer = styled.footer`
  margin-top: auto;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 100%;
  max-width: 100vw;
  min-height: 46px;
  display: flex;
  align-items: center;
  padding: 0 18px;
  background: transparent;
  border-bottom: 2px solid #dcdfe6;
  font-size: 12px;
  line-height: 1;
  color: #6b7280;

  @media (max-width: 768px) {
    padding: 0 16px;
  }

  @media print {
    display: none !important;
  }
`

// Page-level wrapper for routes rendered outside the app shell (public pages).
export const AppFooterLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
  & > :not(footer) {
    flex-shrink: 0;
  }
`

// Wraps the routed page(s) inside <main>. Page roots use `min-height: 100%`;
// that now resolves against this box (the space left above the footer) instead
// of the whole <main>, so the footer is no longer pushed below the fold.
export const AppPageContentContainer = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: ${p => (p.edgeToEdge ? '0' : '0 24px')};
  padding-top: ${p => p.topGap || 0};

  // <main> already pads its left edge by 15px on mobile; add the right side.
  @media (max-width: 835px) {
    padding: ${p => (p.edgeToEdge ? '0' : '0 15px 0 0')};
  }
`
